<h1 mat-dialog-title id="followup-element-title">Seguir</h1>
<mat-dialog-content id="followup-element-content">
  <div class="row">
    <div class="col-12 col-md-12" i18n="@@re-track_selected_record" id="followup-element-text">
      Desea volver a poner en seguimiento el documento seleccionado?
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions id="followup-element-actions">
  <div class="container-fluid">
    <div class="row d-flex justify-content-center align-items-center">
      <button id="followup-element-btn-accept" class="btnOK" mat-button type="button" (click)="followUp()" i18n="@@accept">Aceptar</button>
      <button id="followup-element-btn-cancel" class="btnCancel" mat-button type="button" mat-dialog-close i18n="@@cancel">Cancelar</button>
    </div>
  </div>
</mat-dialog-actions>
